import React from 'react';
import styled from 'styled-components';
import { Button } from '@brokerbay/design-components';

type LoadMoreProps = {
  hasNextPage?: boolean;
  onLoad: () => void;
  loading: boolean;
};

const LoadMore: React.FC<LoadMoreProps> = ({
  hasNextPage,
  onLoad,
  loading,
}) => {
  if (!hasNextPage) return null;

  return (
    <StyledWrapper>
      <Button type="primary" onClick={onLoad} disabled={loading}>
        Load More
      </Button>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  text-align: center;
  margin: 15px;
`;

export default LoadMore;
